import React, { useEffect, useState } from 'react';

import { Typography, Chip } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useLocale } from '../../../i18n/LanguageContext';

const DELIVERY_CHARGE_OPTIONS = [0, 1, 2, 3];

function toDeliveryChargeValue(value) {
  if (value === '' || value === null || value === undefined) {
    return null;
  }

  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? null : numericValue;
}

export default function KitchenServices(props) {
  const { t } = useLocale();
  const [selectedDeliveryCharge, setSelectedDeliveryCharge] = useState(
    toDeliveryChargeValue(props.kitchenData?.deliveryChargePerMile)
  );

  useEffect(() => {
    setSelectedDeliveryCharge(toDeliveryChargeValue(props.kitchenData?.deliveryChargePerMile));
  }, [props.kitchenData?.deliveryChargePerMile]);

  function selectDelivery() {
    const nextProvidesDelivery = !props.kitchenData.providesDelivery;
    const currentDeliveryCharge = toDeliveryChargeValue(props.kitchenData.deliveryChargePerMile);
    const nextDeliveryCharge = currentDeliveryCharge === null ? 0 : currentDeliveryCharge;

    if (nextProvidesDelivery) {
      setSelectedDeliveryCharge(nextDeliveryCharge);
    }

    props.onDataChange({
      ...props.kitchenData,
      providesDelivery: nextProvidesDelivery,
      deliveryChargePerMile: nextProvidesDelivery
        ? nextDeliveryCharge
        : props.kitchenData.deliveryChargePerMile,
    });
  }

  function selectPickup() {
    props.onDataChange({...props.kitchenData, acceptsPickup: !props.kitchenData.acceptsPickup});
  }

  function selectDeliveryCharge(amount) {
    setSelectedDeliveryCharge(amount);
    props.onDataChange({
      ...props.kitchenData,
      deliveryChargePerMile: amount,
    });
  }

  return (
    <div>
        <Typography variant='h5'>{t('kitchenServices.title')}</Typography>

        <FormControlLabel
            value="delivery"
            control={<Checkbox checked={props.kitchenData.providesDelivery} onClick={selectDelivery}/>}
            label={t('kitchenServices.delivery')}
            labelPlacement="end"
        />

        {props.kitchenData.providesDelivery && (
          <div style={{ marginLeft: 32, marginBottom: 12 }}>
            <Typography variant="body2" color="text.secondary" style={{ marginBottom: 8 }}>
              {t('kitchenServices.deliveryChargePrompt')}
            </Typography>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {DELIVERY_CHARGE_OPTIONS.map((amount) => (
                <Chip
                  key={amount}
                  label={amount === 0 ? t('kitchenServices.noCharge') : t('kitchenServices.perMile', { amount })}
                  clickable
                  color={selectedDeliveryCharge === amount ? 'primary' : 'default'}
                  variant={selectedDeliveryCharge === amount ? 'filled' : 'outlined'}
                  onClick={() => selectDeliveryCharge(amount)}
                  data-testid={`delivery-charge-chip-${amount}`}
                />
              ))}
            </div>
          </div>
        )}

        <FormControlLabel
            value="pickup"
            control={<Checkbox checked={props.kitchenData.acceptsPickup} onClick={selectPickup}/>}
            label={t('kitchenServices.pickup')}
            labelPlacement="end"
        />
    </div>
  );
}